// flow weak

import React, {
  PureComponent
}                         from 'react';
import PropTypes          from 'prop-types';
import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../services/fetchTools';
import {
  AnimatedView,
  StatsTable,StatsGraph, ScoreCard,GameTypeTab
}                         from '../../../components';
import Card from '../../../components/card/Card'
import styled from 'styled-components'
import TicketStatus from '../crud/ticketStatus'
import CallStatus from '../crud/callStatus'
import ResponseLeads from '../responseLeads'
import DemoScheduledLeads from '../demoScheduledLeads'
import RenewalCustomers from '../renewalCustomers'
import AppDownloads from '../appDownloads'
import ActiveCustomers from '../../partner/activeCustomers';

class PartnerTasks extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
      super(props);
      this.state = {
        venue: props.statsTable.revenue_per_month.requested_venue_id,
        selected_tab:props.props.match.params.selected_tab,
        total_calls : [],
        open_audio : false,
        recording : '',
        ticket:false,
        call:false,
        leads:true,
        customer:false,
        downloads:false,
        demo:false,
        total_leads:false,
        open_tickets: 0,
        missed_calls: 0,
        response_leads: 0,
        paid_cust: 0,
        app_downloads: 0,
        demo_scheduled:0
      };
      // this.handleChange = this.handleChange.bind(this);
      // // this.playAudio = this.playAudio.bind(this);
      // this.handleAudioClose = this.handleAudioClose.bind(this);
      this.onTicketClick = this.onTicketClick.bind(this);
      this.onCallsClick = this.onCallsClick.bind(this);
      this.onLeadsClick = this.onLeadsClick.bind(this);
      this.onCustomerClick = this.onCustomerClick.bind(this);
      this.onDownloadsClick = this.onDownloadsClick.bind(this);
      this.onTotalLeadsClick = this.onTotalLeadsClick.bind(this);
      this.onDemoScheduledClick = this.onDemoScheduledClick.bind(this);
    }

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('PartnerTasks');
  }

  componentDidMount() {
    this.getWorkbookDetails();
    const {
      actions: {
        fetchStatsTableDataIfNeeded,
        fetchScoreCardDataIfNeeded
      }
    } = this.props;

    if(this.state.selected_tab == 'ticket_and_lead' || (!this.state.selected_tab) ){
        this.setState({selected_tab:'Leads'})
      }
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('PartnerTasks');
  }

  locationChanged() {
    this.setState({venue:this.props.statsTable.revenue_per_month.requested_venue_id}, () => {
      this.getWorkbookDetails()
    })
  }

  getWorkbookDetails() {
     const url = `${getLocationOrigin()}/eagleeye/get_workbook_details/?venue=${this.state.venue}`;
     const options = {...defaultOptions};
     console.log('get details')

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
           this.setState({open_tickets: data.result.open_tickets, missed_calls: data.result.missed_calls, 
            response_leads: data.result.response_leads,paid_cust:data.result.paid_cust,app_downloads:data.result.app_cust,demo_scheduled:data.result.demo_customers,all_leads:data.result.all_customers});
           // alert("fix");
       }).catch(error => error);
  }

  onTicketClick(){
    this.setState({ticket:true,call:false,leads:false,customer:false,downloads:false,total_leads:false,demo:false})
    this.props.props.history.push("/work-bench/ticket_and_lead/" + 'Tickets')
    this.setState({selected_tab:'Tickets'})
    };

  onCallsClick(){
    this.setState({call:true,ticket:false,leads:false,customer:false,downloads:false,total_leads:false,demo:false})
    this.props.props.history.push("/work-bench/ticket_and_lead/" + 'Calls')
    this.setState({selected_tab:'Calls'})
  };

  onLeadsClick(){
    this.setState({leads:true,ticket:false,call:false,customer:false,downloads:false,total_leads:false,demo:false})
    this.props.props.history.push("/work-bench/ticket_and_lead/" + 'Leads')
    this.setState({selected_tab:'Leads'})
  };

  onTotalLeadsClick(){
    this.setState({leads:false,ticket:false,call:false,customer:false,downloads:false,total_leads:true,demo:false})
    this.props.props.history.push("/work-bench/ticket_and_lead/" + 'Total_leads')
    this.setState({selected_tab:'Total_leads'})
  };

  onDemoScheduledClick(){
    this.setState({leads:false,ticket:false,call:false,customer:false,downloads:false,total_leads:false,demo:true})
    this.props.props.history.push("/work-bench/ticket_and_lead/" + 'Demo')
    this.setState({selected_tab:'Demo'})
  };

  onCustomerClick(){
    this.setState({customer:true,leads:false,ticket:false,call:false,downloads:false,total_leads:false,demo:false})
    this.props.props.history.push("/work-bench/ticket_and_lead/" + 'Customers')
    this.setState({selected_tab:'Customers'})
  };

  onDownloadsClick(){
    this.setState({downloads:true,customer:false,leads:false,ticket:false,call:false,total_leads:false,demo:false})
    this.props.props.history.push("/work-bench/ticket_and_lead/" + 'Downloads')
    this.setState({selected_tab:'Downloads'})
  };



  render() {
    console.log('PartnerTasks0')
    console.log(this.state.selected_tab)
    const ticket_style = this.state.open_tickets > 0 ? 'red' : '#4daa0b'
    const call_style = this.state.missed_calls > 0 ? 'red' : '#4daa0b'
    const leads_style = this.state.response_leads > 0 ? 'red' : '#4daa0b'
    const cust_style = this.state.paid_cust > 0 ? 'red' : '#4daa0b'
    const download_style = this.state.app_downloads > 0 ? 'red' : '#4daa0b'
    const demo_style = this.state.demo_scheduled > 0 ? 'red' :'#4daa0b'
    console.log(this.state.missed_calls)
    console.log(this.state.open_tickets)
    console.log(this.state.demo_scheduled)
    // console.log(Card)
    const {
      statsTable,
      scoreCard
    } = this.props;

    const {
      actions: {
        fetchStatsTableDataIfNeeded,
        fetchScoreCardDataIfNeeded,
      }
    } = this.props;

    const StyledRoot = styled.div`
    padding: 0px;
    display: flex;
    flex-direction: row;
    `
    const StyledContainer = styled.div`
      
      width: 100%;
      padding:4px;
      margin-top:5px;
      margin-bottom:5px;
      `

    if(this.state.venue != this.props.statsTable.revenue_per_month.requested_venue_id){
      this.locationChanged()
    }



    return(
    <div >
      <StyledRoot className='col-md-12'>

        <StyledContainer >
          <Card
            title="Hot Leads"
            count={this.state.response_leads ? this.state.response_leads : '-'}
            style = {leads_style}
            action={"Contact"}
            clicked={this.state.selected_tab == 'Leads'}
            onClick={this.onLeadsClick}
          />
        </StyledContainer>

        <StyledContainer >
          <Card
            title="Renewal Customers"
            count={this.state.paid_cust ? this.state.paid_cust : '-'}
            style = {cust_style}
            action={"Contact"}
            clicked={this.state.selected_tab == 'Customers'}
            onClick={this.onCustomerClick}
          />
        </StyledContainer>

        <StyledContainer >
          <Card
            title="Demos"
            count={this.state.demo_scheduled ? this.state.demo_scheduled : '-'}
            style = {demo_style}
            action={"Contact"}
            clicked={this.state.selected_tab == 'Demo'}
            onClick={this.onDemoScheduledClick}
          />
        </StyledContainer>


        <StyledContainer >
          <Card
            title="All Leads"
            count={this.state.all_leads ? this.state.all_leads : '-'}
            style = {leads_style}
            action={"Contact"}
            clicked={this.state.selected_tab == 'Total_leads'}
            onClick={this.onTotalLeadsClick}
          />
        </StyledContainer>

        <StyledContainer >
          <Card
            title="App Not Downloaded"
            count={this.state.app_downloads ? this.state.app_downloads : '-'}
            style = {download_style}
            action={"Contact"}
            clicked={this.state.selected_tab == 'Downloads'}
            onClick={this.onDownloadsClick}
          />
        </StyledContainer>
        <StyledContainer >
          <Card
            title="Open Tickets"
            count={this.state.open_tickets ? this.state.open_tickets : '-'}
            style = {ticket_style}
            action={"Close Them"}
            clicked={this.state.selected_tab == 'Tickets'}
            onClick={this.onTicketClick}
          />
        </StyledContainer>

        <StyledContainer >
          <Card
            title="Missed Calls"
            count={this.state.missed_calls ? this.state.missed_calls : '-'}
            style = {call_style}
            action={"Call Back"}
            clicked={this.state.selected_tab == 'Calls'}
            onClick={this.onCallsClick}
          />
        </StyledContainer>

      </StyledRoot>


      {this.state.selected_tab == 'Tickets' &&
        <TicketStatus props={this.props}/>
        }
      {this.state.selected_tab == 'Calls' &&
        <CallStatus props={this.props}/>
      }
      {this.state.selected_tab == 'Leads' &&
        <ResponseLeads props={this.props} />  
      }
      {this.state.selected_tab == 'Customers' &&
        <RenewalCustomers props={this.props} /> 
      }

      {this.state.selected_tab == 'Downloads' &&
        <AppDownloads props={this.props} /> 
      }

      {this.state.selected_tab == 'Total_leads' &&
        <ActiveCustomers props={this.props} />  
      }
      
      {this.state.selected_tab == 'Demo' &&
        <DemoScheduledLeads props={this.props} />  
      }

    </div>
    );
  }
}

export default PartnerTasks;



// WEBPACK FOOTER //
// ./src/app/views/partner/partnerTasks/partnerTasks.js